import PropTypes from "prop-types";
import React from "react";

const Book = (props) => (
  <svg
    height={13}
    viewBox="0 0 13 13"
    width={13}
    fill="currentColor"
    {...props}
    style={{
      verticalAlign: "middle",
      color: props.color,
      ...props.style,
    }}
  >
    <g
      id="Journey-4---Inbox"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="1.9--all-notifications"
        transform="translate(-1017.000000, -187.000000)"
        fill="#F4F6FC"
        fillRule="nonzero"
      >
        <g
          id="Notifications-dropdown"
          transform="translate(1001.000000, 77.000000)"
        >
          <g id="book-open" transform="translate(16.000000, 110.000000)">
            <path
              d="M11.9186364,0.626363636 C11.4950702,0.55340606 11.0661636,0.515852021 10.6363636,0.514090909 C9.1699431,0.512888714 7.73410499,0.933384162 6.5,1.72545455 C5.26272378,0.943783957 3.82711195,0.533609148 2.36363636,0.543636364 C1.93383643,0.545397476 1.50492978,0.582951514 1.08136364,0.655909091 C0.794727914,0.705325271 0.58668059,0.955984696 0.590909091,1.24681818 L0.590909091,8.33772727 C0.588346887,8.51351191 0.664188667,8.6813095 0.797829613,8.79553253 C0.931470558,8.90975557 1.10903162,8.9585416 1.28227273,8.92863636 C2.99297151,8.63244307 4.75079859,9.03940667 6.15727273,10.0572727 L6.22818182,10.0986364 L6.29318182,10.0986364 C6.42554545,10.1537879 6.57445455,10.1537879 6.70681818,10.0986364 L6.77181818,10.0986364 L6.84272727,10.0572727 C8.23948065,9.01658514 9.99817716,8.58597096 11.7177273,8.86363636 C11.8909684,8.8935416 12.0685294,8.84475557 12.2021704,8.73053253 C12.3358113,8.6163095 12.4116531,8.44851191 12.4090909,8.27272727 L12.4090909,1.18181818 C12.3964223,0.90442805 12.1923235,0.673279972 11.9186364,0.626363636 Z M5.90909091,8.47954545 C4.81584022,7.90440658 3.59894248,7.60423847 2.36363636,7.605 C2.16863636,7.605 1.97363636,7.605 1.77272727,7.605 L1.77272727,1.69590909 C1.96953368,1.68456657 2.16682996,1.68456657 2.36363636,1.69590909 C3.62427342,1.69451589 4.85739934,2.06445367 5.90909091,2.75954545 L5.90909091,8.47954545 Z M11.2272727,7.62863636 C11.0263636,7.62863636 10.8313636,7.62863636 10.6363636,7.62863636 C9.40105752,7.62787484 8.18415978,7.92804295 7.09090909,8.50318182 L7.09090909,2.75954545 C8.14260066,2.06445367 9.37572658,1.69451589 10.6363636,1.69590909 C10.83317,1.68456657 11.0304663,1.68456657 11.2272727,1.69590909 L11.2272727,7.62863636 Z M11.9186364,10.0809091 C11.4950702,10.0079515 11.0661636,9.97039748 10.6363636,9.96863636 C9.1699431,9.96743417 7.73410499,10.3879296 6.5,11.18 C5.26589501,10.3879296 3.8300569,9.96743417 2.36363636,9.96863636 C1.93383643,9.97039748 1.50492978,10.0079515 1.08136364,10.0809091 C0.92600521,10.1055634 0.78688893,10.1911446 0.694830306,10.3186957 C0.602771681,10.4462468 0.565369647,10.6052392 0.590909091,10.7604545 C0.653429922,11.0799372 0.962573167,11.288675 1.28227273,11.2272727 C2.99297151,10.9310794 4.75079859,11.338043 6.15727273,12.3559091 C6.36241527,12.5019688 6.63758473,12.5019688 6.84272727,12.3559091 C8.24920141,11.338043 10.0070285,10.9310794 11.7177273,11.2272727 C12.0374268,11.288675 12.3465701,11.0799372 12.4090909,10.7604545 C12.4346304,10.6052392 12.3972283,10.4462468 12.3051697,10.3186957 C12.2131111,10.1911446 12.0739948,10.1055634 11.9186364,10.0809091 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Book.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object,
};

export default Book;
